var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlurFace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_43784)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.4935 1.33398C4.8135 1.33398 1.8335 4.32065 1.8335 8.00065C1.8335 11.6807 4.8135 14.6673 8.4935 14.6673C12.1802 14.6673 15.1668 11.6807 15.1668 8.00065C15.1668 4.32065 12.1802 1.33398 8.4935 1.33398ZM8.50016 13.334C5.5535 13.334 3.16683 10.9473 3.16683 8.00065C3.16683 5.05398 5.5535 2.66732 8.50016 2.66732C11.4468 2.66732 13.8335 5.05398 13.8335 8.00065C13.8335 10.9473 11.4468 13.334 8.50016 13.334ZM10.8335 7.33398C11.3868 7.33398 11.8335 6.88732 11.8335 6.33398C11.8335 5.78065 11.3868 5.33398 10.8335 5.33398C10.2802 5.33398 9.8335 5.78065 9.8335 6.33398C9.8335 6.88732 10.2802 7.33398 10.8335 7.33398ZM6.16683 7.33398C6.72016 7.33398 7.16683 6.88732 7.16683 6.33398C7.16683 5.78065 6.72016 5.33398 6.16683 5.33398C5.6135 5.33398 5.16683 5.78065 5.16683 6.33398C5.16683 6.88732 5.6135 7.33398 6.16683 7.33398ZM8.50016 11.6673C10.0535 11.6673 11.3735 10.694 11.9068 9.33398H5.0935C5.62683 10.694 6.94683 11.6673 8.50016 11.6673Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_43784"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlurFace);
export default __webpack_public_path__ + "static/media/blur-face.d3b66f8a102d952e160441c1f9748e08.svg";
export { ForwardRef as ReactComponent };